import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { CardDashboard, CardContent, Badge } from '@percent/lemonade'

type LinkedEntityCardProps = {
  type: 'partner' | 'organisation'
  entityId: string
  entityName?: string
  action?: ReactNode
}

export function LinkedEntityCard({ type, entityId, entityName, action }: LinkedEntityCardProps) {
  const { t } = useTranslation()

  const isPartner = type === 'partner'
  const title = isPartner ? t('memberProfile.linkedPartner') : t('memberProfile.linkedOrganization')
  const nameLabel = isPartner ? t('memberProfile.partnerName') : t('memberProfile.organizationName')
  const idLabel = isPartner ? t('memberProfile.partnerId') : t('memberProfile.organizationId')

  return (
    <CardDashboard title={title} headingLevel="h4" action={action}>
      <CardContent title={nameLabel} testId="linked-entity-name">
        {entityName || <span style={{ color: 'var(--content-disabled, #b6b4b9)' }}>{t('typography.nullValue')}</span>}
      </CardContent>
      <CardContent title={idLabel} testId="linked-entity-id">
        <Badge variant="default">{entityId}</Badge>
      </CardContent>
    </CardDashboard>
  )
}
